import { Injectable } from '@angular/core';
import { Firestore, initializeFirestore, doc, getDoc, setDoc } from '@angular/fire/firestore';
import { ImageGalleryImage, WebsiteData } from '../state-management/model/interfaces/state.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FirestoreService {

  shop_id = environment.shopId;

  constructor(private firestore: Firestore) {
    this.firestore = initializeFirestore(this.firestore.app, {});
  }

  async getWebsiteData(): Promise<WebsiteData | null> {
    const docPath = `/clients/${this.shop_id}/website-data/initialValues`;
    const data = await this.getDocument(docPath);
    return data as WebsiteData;
  }

  async updateWebsiteData(data: WebsiteData): Promise<void> {
    const docPath = `/clients/${this.shop_id}/website-data/initialValues`;
    const document = doc(this.firestore, docPath);
    console.log('Updating website data:', data);
    await setDoc(document, data);
  }

  async getImageGallery(): Promise<ImageGalleryImage[] | null> {
    const docPath = `/clients/${this.shop_id}/website-data/imageGallery`;
    const data = await this.getDocument<{ images: ImageGalleryImage[] }>(docPath);
    if (!data) {
      console.warn('No image gallery data found');
      return null;
    }
    if (!Array.isArray(data.images)) {
      console.error('Invalid image gallery data format:', data);
      return null;
    }
    return data.images as ImageGalleryImage[];
  }

  async updateImageGallery(data: ImageGalleryImage[]): Promise<void> {
    const docPath = `/clients/${this.shop_id}/website-data/imageGallery`;
    const document = doc(this.firestore, docPath);
    console.log('Updating image gallery:', data);
    await setDoc(document, {images: data});
  }


  // async setDocument<T>(path: string, data: T): Promise<void> {
  //   const document = doc(this.firestore, path);
  //   await document.
  // }

  async getDocument<T>(path: string): Promise<T | null> {
    const document = doc(this.firestore, path);
    const docSnap = await getDoc(document);
    if (docSnap.exists()) {
      return docSnap.data() as T;
    } else {
      return null;
    }
  }

}
